module.exports = __webpack_public_path__ + "static/media/default-image.ae1cd6a5.png";